"use client";
import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { cn as l } from "@deputy-ai/common";
import { Cross2Icon as D } from "@radix-ui/react-icons";
import { cva as b } from "class-variance-authority";
import { Dialog as o } from "radix-ui";
const r = o.Root, h = o.Trigger, m = o.Portal, C = o.Close;
function d({ className: a, ...t }) {
  return /* @__PURE__ */ e(
    o.Overlay,
    {
      className: l(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80",
        a
      ),
      ...t
    }
  );
}
const v = b("", {
  variants: {
    size: {
      sm: "w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl",
      default: "w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-3xl",
      lg: "w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-3xl 2xl:max-w-4xl",
      xl: "w-full max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl"
    }
  }
});
function y({
  className: a,
  children: t,
  overlay: x = !0,
  closeOnClickOutside: c = !0,
  onPointerDownOutside: s,
  autoScroll: g = !0,
  closeButton: f = !0,
  size: u = "default",
  ...p
}) {
  const w = (i) => {
    c || i.preventDefault(), s == null || s(i);
  };
  return /* @__PURE__ */ n(m, { children: [
    x && /* @__PURE__ */ e(d, {}),
    /* @__PURE__ */ n(
      o.Content,
      {
        className: l(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed top-[50%] left-[50%] z-50 grid max-h-[calc(100%-100px)] max-w-[calc(100%-100px)] translate-x-[-50%] translate-y-[-50%] gap-4 border border-gray-200 p-6 shadow-lg duration-200 sm:rounded-lg",
          g ? "overflow-auto" : "",
          v({ size: u }),
          a
        ),
        onPointerDownOutside: w,
        ...p,
        children: [
          t,
          f && /* @__PURE__ */ n(o.Close, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none", children: [
            /* @__PURE__ */ e(D, { className: "h-4 w-4" }),
            /* @__PURE__ */ e("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
}
function N({ className: a, ...t }) {
  return /* @__PURE__ */ e(
    "div",
    {
      className: l("flex flex-col space-y-1.5 text-left", a),
      ...t
    }
  );
}
function T({ className: a, ...t }) {
  return /* @__PURE__ */ e(
    "div",
    {
      className: l(
        "flex flex-row sm:flex-row sm:justify-end sm:space-x-2",
        a
      ),
      ...t
    }
  );
}
function z({ className: a, ...t }) {
  return /* @__PURE__ */ e(
    o.Title,
    {
      className: l(
        "text-lg leading-none font-semibold tracking-tight",
        a
      ),
      ...t
    }
  );
}
function j({ className: a, ...t }) {
  return /* @__PURE__ */ e(
    o.Description,
    {
      className: l("text-muted-foreground text-sm", a),
      ...t
    }
  );
}
const k = function(t) {
  return /* @__PURE__ */ e(r, { ...t });
}, P = Object.assign(k, {
  Root: r,
  Portal: m,
  Overlay: d,
  Trigger: h,
  Close: C,
  Content: y,
  Header: N,
  Footer: T,
  Title: z,
  Description: j
});
export {
  P as Dialog
};
